import { confirmAlert } from 'react-confirm-alert';
import {Link} from "react-router-dom";
import {useState} from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {vendorDelete} from "../../api/vendor";
import Button from "../../components/UI/Button";

const VendorListAction = ({row}) => {
  const [toastId, setToastId] = useState(null);

  const queryClient = useQueryClient()

  const {mutate,isPending} = useMutation({
    mutationFn: vendorDelete,
    onMutate: () => {
      setToastId(toast.loading("Please wait..."))
    },
    onSuccess: (response, payload) => {
      toast.update(toastId, { render: "Vendor Deleted!", type: "success", isLoading: false, autoClose: true  });
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'vendors',
      });
    },
    onError: () => {
      toast.update(toastId, { render: "Something happened!", type: "error", isLoading: false, autoClose: true });
    }
  })

  const deleteHandler = () => {
    confirmAlert({
      title: 'Delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            mutate({id: row.id})
          },
        },
        {
          label: 'No',
          onClick: () => {
            return;
          }
        }
      ]
    });

  };

  return (
    <>
      <Link  to={"/vendors/edit/"+row.id} className="mr_5">
        <Button text={'Edit'} variant={'has_border_radius btn_transparent'} size={'btn_sm'} />
      </Link>
      <Link  to={"/vendor-details/"+row.id} className="mr_5">
        <Button text={'Details'} classes={'has_border_radius'} variant={'btn_black'} size={'btn_sm'} />
      </Link>
      <Button text={'Delete'} variant={'btn_danger'} classes={'has_border_radius'} size={'btn_sm'} isPending={isPending} onClickHandler={deleteHandler} />
    </>
  );
};

export default VendorListAction;